import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { StyledHeader, StyledProfile } from '@med-fe/ui';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getIsAccessDenied } from '../../store/user/user-reducer';
import NavbarMenu from '../navbar/NavbarMenu';
import Export from './export/Export';
import styles from './header.module.scss';
import ProfilePanel from './profile-panel/ProfilePanel';

export default function Header({ routes }) {
  const { pathname } = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const isAccessDenied = useSelector(getIsAccessDenied);

  const profilePanel = ({ accounts, onSignHandler }) => <ProfilePanel user={accounts[0]} onSignOut={onSignHandler} />;

  return (
    <StyledHeader isAuthenticated={isAuthenticated} style={{ position: 'relative', padding: 0 }}>
      <div className={styles.headerFlexRow}>
        <div className={styles.headerLeft}>
          <AuthenticatedTemplate>{!isAccessDenied && <NavbarMenu routes={routes} />}</AuthenticatedTemplate>
        </div>
        <div className={styles.headerRight}>
          <AuthenticatedTemplate>
            {!isAccessDenied && (
              <>
                {!pathname.includes('dashboard') &&
                  !pathname.includes('import') &&
                  !pathname.includes('hours-of-operation-change-request') &&
                  !pathname.includes('user-role-configuration') && <Export />}
              </>
            )}
          </AuthenticatedTemplate>
          {isAuthenticated && <StyledProfile profilePanel={profilePanel} />}
        </div>
        <div className={styles.headerTitle}>
          <span className={styles.headerTitle__my}>My</span>
          <span className={styles.headerTitle__office}>Office</span>
          <span className={styles.headerTitle__directory}>Directory</span>
        </div>
      </div>
    </StyledHeader>
  );
}
